  import { Component, OnDestroy, OnInit } from "@angular/core";
  import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
  import { Router } from "@angular/router";
  import { PromotionsService } from "src/app/features/promotions/promotions.service";
import { FeeConfigService } from "../../fee-config.service";
import * as moment from "moment";
import { hide } from "@popperjs/core";
  
  @Component({
    selector: 'app-all-fee',
    templateUrl: './all-fee.component.html',
    styleUrls: ['./all-fee.component.scss'],
    providers: []
  })
  export class AllFeeComponent extends FeaturesBaseComponent implements OnInit, OnDestroy{
    searchValue: string;
    rowSelection;
    rowData;
    columnDefs;
    private gridApi;
    private gridColumnApi;
    selectedRows: any;
    showUpdateRetailer: boolean;
    feeId: any;
    constructor(
      private router: Router,
      private feeConfigService:FeeConfigService
    ) {
      super();
      this.getAllBannersData();
    }
  
    ngOnInit(): void {
      super.ngOnInit();
    }
  
    ngOnDestroy() {
      super.ngOnDestroy();
    }
  
    getAllBannersData() {
      this.feeConfigService.getAllFeeDetails().subscribe({
        next: (res: any) => {
          if (res["httpcode"] == 200) {
            this.setGrid(res.data);
          }
        },
      });
    }
  
    setGrid(data: any) {
      this.rowData = data;
      this.rowSelection = "single";
  
      this.columnDefs = [
        { field: "", headerName: "Action", width: 60, checkboxSelection: true },
        {
          field: "paymentType",
          headerName: "Payment Type",
          width: 230
        },
        {
          field: "feeValue",
          headerName: "Fee",
          width: 170,
        },
        {
          field: "feeType",
          headerName: "Fee Type",
          width: 170,
        },
        {
          field: "validityStartDttm",
          headerName: "Start Date",
          width: 200,
          cellRenderer: (data) => {if(data.value){ return moment(data.value).format('MM/DD/YYYY');}}
        },
        {
          field: "validityEndDttm",
          headerName: "End Date",
          width: 200,
          cellRenderer: (data) => {if(data.value){ return moment(data.value).format('MM/DD/YYYY');}}
        },
        { field: "createdDttm", headerName: "Created Date", sort: "desc",cellRenderer: (data) => {if(data.value){ return moment(data.value).format('MM/DD/YYYY');}}},
        { field: 'createdBy', headerName: 'Created By', width: 230  },
        { field: 'updatedBy', headerName: 'Updated By', width: 230  },
      ];
    }
    // On grid ready
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    }
    manageFee() {
      this.router.navigate([
        `features/consumers/fee-config/manage-fee/${this.feeId}`,
      ]);
    }
    manageFeeHistory(){
      this.router.navigate([
        `features/consumers/fee-config/config-history/${this.feeId}`,
      ]);
    }
    onSelectionChanged(e) {
      this.selectedRows = this.gridApi.getSelectedRows();
  
      if (this.selectedRows && this.selectedRows.length > 0) {
        this.showUpdateRetailer = true;
        this.feeId = this.selectedRows[0].id;
  
        return;
      }
      this.showUpdateRetailer = false;
    }
  
    quickSearch() {
      this.gridApi.setQuickFilter(this.searchValue);
    }
  
    addFeeConfig() {
      this.router.navigate([`features/consumers/fee-config/add-fee`]);
    }
  }
  